import { render } from "./ForgotPasswordUp.vue?vue&type=template&id=109ad1a7&scoped=true"
import script from "./ForgotPasswordUp.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordUp.vue?vue&type=script&lang=js"

import "./ForgotPasswordUp.vue?vue&type=style&index=0&id=109ad1a7&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109ad1a7"]])

export default __exports__